// 合并批次：第28批（电商与SEO运营类，IDs 215-221）
//           第32批（电商/社媒/运营扩展类，IDs 204,206,214,272-275）
export const talentsBatch2832 = [
  // ==================== 第28批 ====================
  {
    id: 215,
    name: '薛俊豪',
    role: '快手策略师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20Kuaishou%20strategy%20specialist%20in%20trendy%20casual%20attire%20approachable%20expression%20age%2030%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b28-001&orientation=portrait',
    salary: '¥1500/月',
    tags: ['快手运营', '老铁文化', '同城引流', '直播带货', '电商转化', '信任建设'],
    description: '快手平台运营与老铁文化专家，擅长快手内容策划和同城/直播引流，深谙老铁经济和信任建设。',
    skills: [
      { name: '快手内容策划', level: 96 },
      { name: '同城直播引流', level: 95 },
      { name: '电商转化能力', level: 94 },
      { name: '粉丝信任建设', level: 97 },
      { name: '老铁文化理解', level: 98 },
    ],
    performance: { monthly_videos: 90, average_engagement: 25000 },
    cases: [
      { title: '某农产品品牌快手运营', result: '运营快手账号，发布真实接地气内容，粉丝从0增长至60万，通过直播带货年销售额破3000万，帮助农民增收', duration: '1年', tags: ['农产品', '粉丝增长', '直播带货', '助农增收'] },
      { title: '某本地商家同城引流', result: '策划同城短视频和直播，精准触达本地用户，到店客流提升200%，月营业额从20万提升至80万', duration: '6个月', tags: ['同城引流', '本地商家', '客流翻倍', '营业额增长'] },
      { title: '某手工艺人快手变现', result: '帮助手工艺人建立快手账号，展示制作过程，建立信任，粉丝30万+，月收入从5000元提升至15万元', duration: '8个月', tags: ['手工艺人', '信任建设', '粉丝增长', '收入翻倍'] },
    ],
    reviews: [
      { name: '祁农场主', company: '某农产品品牌', rating: 5, content: '薛建国对快手老铁文化理解很深，他的内容策划真实接地气。他帮我们通过快手卖出了3000万农产品，还帮助了很多农民增收。', date: '2024-01-30' },
      { name: '宿店主', company: '某本地餐饮', rating: 5, content: '他的同城引流策略非常有效，我们的到店客流翻了2倍。他对本地市场的理解很到位，营业额从20万涨到了80万。', date: '2024-02-22' },
      { name: '双手工艺人', company: '个体创作者', rating: 5, content: '他帮我建立的快手账号改变了我的生活，现在我有30万粉丝，月收入达到了15万。他教我怎么和老铁建立信任，非常感谢他。', date: '2024-03-18' },
    ],
    profile: {
      identity: { roleName: '快手运营与老铁文化专家，专注于通过真实内容和信任建设实现商业转化', personality: '真诚接地气、善于沟通、注重信任、执行力强，能够与快手老铁建立深度连接', background: '新媒体或市场营销专业背景，深入理解快手平台文化、老铁经济、同城流量，熟悉直播电商' },
      mission: { duties: '负责快手内容策划、同城/直播引流、电商转化、粉丝信任建设、老铁文化运营', goals: '提升快手影响力和转化，粉丝增长率达到150%以上，直播GMV月均达到15万以上', collaboration: '与内容团队协作选题，与主播配合直播，与电商团队承接转化' },
      delivery: { example: '输出快手内容、同城引流方案、直播策划、信任建设策略、数据分析报告', workflow: '1.内容策划 → 2.视频发布 → 3.同城推广 → 4.直播引流 → 5.信任建设 → 6.电商转化 → 7.效果复盘', format: '提供内容方案、引流策略、直播计划、数据报告、优化建议等标准化交付物' },
      metrics: { quality: '粉丝增长率、内容互动率、同城引流效果、直播GMV、粉丝信任度', acceptance: '粉丝稳定增长，互动率高，引流效果好，GMV达标，粉丝信任度高', improvement: '持续深化老铁文化理解，优化内容策略，提升转化能力，关注粉丝反馈' },
    },
  },
  {
    id: 216,
    name: '方雅琪',
    role: '电商运营师（全平台）',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20e-commerce%20operations%20expert%20in%20modern%20business%20attire%20confident%20expression%20age%2029%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b28-002&orientation=portrait',
    salary: '¥1688/月',
    tags: ['全平台电商', '店铺管理', '大促活动', '直播协同', '平台规则', '运营策略'],
    description: '淘宝/拼多多/京东等电商平台全链路运营专家，擅长店铺日常管理和大促活动策划，提升电商业绩。',
    skills: [
      { name: '店铺日常管理', level: 96 },
      { name: '大促活动策划', level: 95 },
      { name: '直播带货协同', level: 94 },
      { name: '平台规则监控', level: 97 },
      { name: '多平台运营', level: 93 },
    ],
    performance: { monthly_gmv: 800000, promotion_roi: '1:7' },
    cases: [
      { title: '某服装品牌全平台运营', result: '运营淘宝、京东、拼多多三大平台店铺，年度GMV突破1.2亿，双11单日GMV破2000万，成为类目TOP10', duration: '1年', tags: ['全平台运营', 'GMV破亿', '双11爆发', '类目TOP'] },
      { title: '某美妆品牌大促策划', result: '策划618大促活动，多平台联动，活动期间GMV破5000万，同比增长300%，ROI达到1:8', duration: '2个月', tags: ['大促策划', '多平台联动', 'GMV破5000万', '高ROI'] },
      { title: '某食品店铺直播电商', result: '整合店铺和直播，建立直播带货体系，直播GMV占比从10%提升至60%，店铺总GMV提升150%', duration: '6个月', tags: ['直播电商', '体系建设', 'GMV占比提升', '总GMV增长'] },
    ],
    reviews: [
      { name: '严CEO', company: '某服装品牌', rating: 5, content: '方雅琪的全平台运营能力非常强，她能同时管理三大平台。她的运营让我们的年度GMV突破了1.2亿，双11单日破了2000万。', date: '2024-01-30' },
      { name: '汤电商总监', company: '某美妆品牌', rating: 5, content: '她的大促策划能力很强，多平台联动效果很好。她策划的618让我们的GMV破了5000万，ROI达到了1:8。', date: '2024-02-22' },
      { name: '邱店铺负责人', company: '某食品品牌', rating: 5, content: '她整合的直播电商体系非常成功，直播GMV占比提升到了60%。她的运营让我们的店铺总GMV提升了150%。', date: '2024-03-18' },
    ],
    profile: {
      identity: { roleName: '全平台电商运营专家，专注于通过多平台运营和大促策划提升电商业绩', personality: '统筹能力强、数据敏感、执行力强、善于协调，能够同时管理多个平台店铺', background: '电子商务或市场营销专业背景，精通各大电商平台规则、店铺运营、大促策划，熟悉直播电商' },
      mission: { duties: '负责店铺日常管理、大促活动策划、直播带货协同、平台规则监控、多平台运营', goals: '提升电商业绩，月度GMV达到80万以上，大促ROI达到1:6以上', collaboration: '与运营团队协作策划，与直播团队配合带货，与客服团队处理售后' },
      delivery: { example: '输出店铺运营方案、大促活动方案、直播协同计划、规则监控报告、数据分析报告', workflow: '1.店铺诊断 → 2.运营规划 → 3.日常管理 → 4.大促策划 → 5.直播协同 → 6.数据监控 → 7.效果复盘', format: '提供运营方案、活动方案、协同计划、监控报告、数据分析等标准化交付物' },
      metrics: { quality: '店铺GMV、大促ROI、直播GMV占比、平台合规性、客户满意度', acceptance: 'GMV稳定增长，大促ROI达标，直播协同顺畅，平台合规，客户满意', improvement: '持续优化运营策略，提升大促效果，完善直播体系，关注平台变化' },
    },
  },
  {
    id: 217,
    name: '孔志强',
    role: '百度SEO专家',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20Baidu%20SEO%20expert%20in%20smart%20business%20casual%20attire%20analytical%20expression%20age%2033%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b28-003&orientation=portrait',
    salary: '¥1750/月',
    tags: ['百度SEO', '关键词策略', '站内优化', '百度生态', '排名监控', '流量增长'],
    description: '百度搜索引擎优化与生态营销专家，擅长关键词策略和站内优化，提升百度搜索排名和自然流量。',
    skills: [
      { name: '关键词策略', level: 97 },
      { name: '站内优化能力', level: 96 },
      { name: '百度生态布局', level: 95 },
      { name: '排名监控分析', level: 94 },
      { name: 'SEO技术能力', level: 93 },
    ],
    performance: { keyword_rankings: 200, traffic_growth: '+180%' },
    cases: [
      { title: '某医疗机构百度SEO', result: '优化网站SEO，核心关键词排名前3占比85%，自然流量从日均500提升至3000，咨询量提升250%，年度节省推广费用200万', duration: '8个月', tags: ['医疗SEO', '排名提升', '流量增长', '成本节约'] },
      { title: '某教育机构百度生态布局', result: '布局百度百科、知道、贴吧、文库，建立品牌百度生态，品牌搜索量提升300%，品牌词霸屏率90%', duration: '6个月', tags: ['生态布局', '品牌霸屏', '搜索量提升', '多产品布局'] },
      { title: '某本地服务SEO优化', result: '优化本地服务SEO，地域关键词排名第一占比80%，本地客户咨询量提升400%，成为区域龙头', duration: '5个月', tags: ['本地SEO', '地域排名', '咨询量增长', '区域领先'] },
    ],
    reviews: [
      { name: '祁院长', company: '某医疗机构', rating: 5, content: '孔志强的百度SEO能力非常专业，他优化后我们的关键词排名大幅提升。他的SEO让我们的自然流量增长了5倍，节省了200万推广费。', date: '2024-01-30' },
      { name: '宿校长', company: '某教育机构', rating: 5, content: '他的百度生态布局非常全面，百科、知道、贴吧都做得很好。他的布局让我们的品牌在百度上实现了霸屏，搜索量提升了3倍。', date: '2024-02-22' },
      { name: '双老板', company: '某本地服务', rating: 5, content: '他的本地SEO优化非常精准，我们的地域关键词排名都到了第一。他的优化让我们的咨询量增长了4倍，成了区域龙头。', date: '2024-03-18' },
    ],
    profile: {
      identity: { roleName: '百度SEO专家，专注于通过搜索引擎优化和百度生态布局提升品牌在百度的影响力', personality: '技术扎实、数据敏感、善于分析、注重长期，能够制定有效的SEO策略', background: 'SEO或网络营销专业背景，精通百度搜索算法、关键词研究、站内优化，熟悉百度生态产品' },
      mission: { duties: '负责关键词策略、站内优化、百科/知道/贴吧布局、排名监控、流量分析', goals: '提升百度搜索排名和流量，核心词排名前3占比达到80%以上，自然流量提升150%以上', collaboration: '与技术团队协作网站优化，与内容团队创作SEO内容，与数据团队分析效果' },
      delivery: { example: '输出关键词策略、站内优化方案、百度生态布局、排名监控报告、流量分析报告', workflow: '1.关键词研究 → 2.站内优化 → 3.内容优化 → 4.外链建设 → 5.生态布局 → 6.排名监控 → 7.策略调整', format: '提供关键词列表、优化方案、布局计划、监控报告、分析报告等标准化交付物' },
      metrics: { quality: '关键词排名、自然流量、转化率、生态覆盖度、ROI', acceptance: '排名稳定提升，流量持续增长，转化效果好，生态布局完善', improvement: '持续优化SEO策略，关注算法变化，完善生态布局，提升转化效果' },
    },
  },
  {
    id: 218,
    name: '严德华',
    role: '私域流量运营师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20private%20domain%20traffic%20operations%20specialist%20in%20modern%20business%20attire%20strategic%20expression%20age%2032%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b28-004&orientation=portrait',
    salary: '¥1750/月',
    tags: ['私域运营', '企微SCRM', '社群分层', '复购增长', '用户旅程', 'LTV提升'],
    description: '私域体系搭建与用户生命周期管理专家，擅长企微SCRM配置和社群分层运营，提升用户LTV和复购率。',
    skills: [
      { name: '企微SCRM配置', level: 96 },
      { name: '社群分层运营', level: 97 },
      { name: '复购增长策略', level: 95 },
      { name: '用户旅程设计', level: 94 },
      { name: 'LTV提升能力', level: 93 },
    ],
    performance: { private_domain_users: 50000, repurchase_rate: '45%' },
    cases: [
      { title: '某美妆品牌私域体系搭建', result: '从0搭建私域体系，沉淀私域用户8万+，建立分层运营机制，复购率从15%提升至45%，私域GMV年度破5000万', duration: '1年', tags: ['私域搭建', '用户沉淀', '复购率提升', 'GMV破5000万'] },
      { title: '某教育机构企微SCRM', result: '配置企微SCRM系统，实现用户自动化运营，销售效率提升80%，用户LTV提升120%，续费率提升至75%', duration: '4个月', tags: ['SCRM配置', '自动化运营', 'LTV提升', '续费率提升'] },
      { title: '某电商品牌社群运营', result: '建立社群分层运营体系，精准推送个性化内容，社群活跃度85%，社群转化率达到25%', duration: '6个月', tags: ['社群分层', '精准推送', '高活跃度', '高转化率'] },
    ],
    reviews: [
      { name: '方市场总监', company: '某美妆品牌', rating: 5, content: '严建国的私域运营能力非常强，他从零帮我们搭建了完整的私域体系。他的分层运营让复购率提升到了45%，私域GMV破了5000万。', date: '2024-01-30' },
      { name: '孔运营总监', company: '某教育机构', rating: 5, content: '他配置的企微SCRM系统非常好用，实现了用户自动化运营。他的运营让我们的销售效率和用户LTV都大幅提升了。', date: '2024-02-22' },
      { name: '严电商经理', company: '某电商品牌', rating: 5, content: '他的社群分层运营做得很好，精准推送让转化率达到了25%。他的运营让我们的社群活跃度保持在85%，非常难得。', date: '2024-03-18' },
    ],
    profile: {
      identity: { roleName: '私域流量运营专家，专注于通过私域体系搭建和精细化运营提升用户价值', personality: '系统思维强、注重长期、数据驱动、善于设计，能够构建完整的私域运营体系', background: '市场营销或用户运营专业背景，精通私域运营、SCRM系统、社群运营，熟悉用户生命周期管理' },
      mission: { duties: '负责企微SCRM配置、社群分层运营、复购增长策略、用户旅程设计、LTV提升', goals: '提升用户LTV和复购率，复购率达到40%以上，私域GMV占比达到50%以上', collaboration: '与销售团队配合转化，与客服团队协作服务，与数据团队分析效果' },
      delivery: { example: '输出私域体系方案、SCRM配置、社群运营策略、用户旅程图、数据分析报告', workflow: '1.体系设计 → 2.SCRM配置 → 3.用户沉淀 → 4.分层运营 → 5.旅程优化 → 6.复购促进 → 7.效果分析', format: '提供体系方案、配置文档、运营策略、旅程图、数据报告等标准化交付物' },
      metrics: { quality: '私域用户量、复购率、用户LTV、社群活跃度、私域GMV', acceptance: '用户稳定增长，复购率提升，LTV增长，社群活跃，GMV达标', improvement: '持续优化运营策略，提升用户体验，完善旅程设计，关注数据反馈' },
    },
  },
  {
    id: 220,
    name: '费德明',
    role: '跨境电商运营专家',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20cross-border%20e-commerce%20expert%20in%20international%20business%20attire%20professional%20expression%20age%2035%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b28-006&orientation=portrait',
    salary: '¥2250/月',
    tags: ['跨境电商', 'Amazon运营', 'Listing优化', '海外仓', '品牌备案', '广告投放'],
    description: 'Amazon/Shopee/Lazada等跨境平台运营专家，擅长Listing优化和海外仓管理，助力品牌出海。',
    skills: [
      { name: 'Listing优化', level: 97 },
      { name: '海外仓管理', level: 95 },
      { name: '品牌备案', level: 94 },
      { name: '广告投放', level: 96 },
      { name: '合规检查', level: 93 },
    ],
    performance: { monthly_sales: 500000, roi: '1:6' },
    cases: [
      { title: '某3C品牌Amazon运营', result: '运营Amazon店铺，优化Listing，月销售额从10万美元提升至50万美元，成为类目Best Seller，年度销售额破500万美元', duration: '1年', tags: ['Amazon运营', 'Listing优化', 'Best Seller', '销售破500万'] },
      { title: '某家居品牌跨境多平台', result: '拓展Amazon、Shopee、Lazada多平台，建立海外仓体系，跨境销售额从0增长至年度3000万人民币', duration: '1.5年', tags: ['多平台拓展', '海外仓', '从0到3000万', '体系建设'] },
      { title: '某服装品牌Amazon广告', result: '优化Amazon广告投放，ACoS从35%降至18%，广告ROI提升至1:8，广告带动自然流量提升200%', duration: '4个月', tags: ['广告优化', 'ACoS降低', 'ROI提升', '流量增长'] },
    ],
    reviews: [
      { name: '岑CEO', company: '某3C品牌', rating: 5, content: '费建华的Amazon运营能力非常专业，他的Listing优化让我们的产品成了Best Seller。他的运营让我们的年度销售额破了500万美元。', date: '2024-01-30' },
      { name: '彭总经理', company: '某家居品牌', rating: 5, content: '他的跨境多平台运营能力很强，帮我们建立了完整的海外仓体系。他的运营让我们的跨境销售额从0做到了3000万。', date: '2024-02-22' },
      { name: '滕投放经理', company: '某服装品牌', rating: 5, content: '他的Amazon广告优化非常专业，ACoS降低了一半，ROI提升到了1:8。他的投放还带动了自然流量增长。', date: '2024-03-18' },
    ],
    profile: {
      identity: { roleName: '跨境电商运营专家，专注于帮助中国品牌成功出海，拓展国际市场', personality: '国际视野、注重细节、善于学习、执行力强，能够应对跨境电商的复杂挑战', background: '国际贸易或电子商务专业背景，精通Amazon等跨境平台规则、Listing优化、海外仓管理，熟悉跨境物流和合规' },
      mission: { duties: '负责Listing优化、海外仓管理、品牌备案、广告投放、合规检查', goals: '提升跨境销售业绩，月销售额达到50万以上，广告ROI达到1:5以上', collaboration: '与产品团队确认选品，与物流团队管理海外仓，与财务团队处理结算' },
      delivery: { example: '输出Listing优化方案、海外仓管理方案、品牌备案文件、广告投放策略、合规检查报告', workflow: '1.选品分析 → 2.Listing优化 → 3.海外仓布局 → 4.广告投放 → 5.品牌备案 → 6.合规检查 → 7.数据优化', format: '提供优化方案、管理文档、备案资料、投放策略、合规报告等标准化交付物' },
      metrics: { quality: '销售额、Listing排名、广告ROI、海外仓周转率、合规符合率', acceptance: '销售额稳定增长，排名提升，ROI达标，海外仓高效，合规无风险', improvement: '持续优化Listing，完善海外仓布局，提升广告效果，关注平台变化' },
    },
  },
  {
    id: 221,
    name: '戴志强',
    role: '短视频剪辑指导师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20video%20editing%20instructor%20in%20creative%20tech%20attire%20teaching%20expression%20age%2031%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b28-007&orientation=portrait',
    salary: '¥1625/月',
    tags: ['剪辑指导', '软件教学', '调色技巧', '音频特效', '爆款模板', '创意启发'],
    description: '短视频剪辑技术与创作指导专家，擅长剪辑软件操作指南和调色/音频/特效技巧，提升团队剪辑能力。',
    skills: [
      { name: '剪辑软件操作', level: 97 },
      { name: '调色音频特效', level: 96 },
      { name: '爆款模板生成', level: 95 },
      { name: '创意启发能力', level: 94 },
      { name: '教学指导能力', level: 98 },
    ],
    performance: { students_trained: 200, skill_improvement: '+150%' },
    cases: [
      { title: '某MCN机构剪辑师培训', result: '培训剪辑师60人，建立标准化剪辑流程，剪辑效率提升80%，视频质量评分从3.5提升至4.6分', duration: '6个月', tags: ['剪辑师培训', '流程标准化', '效率提升', '质量提升'] },
      { title: '某品牌爆款模板库建设', result: '开发50+爆款剪辑模板，团队使用模板后视频产出效率提升200%，爆款率提升至60%', duration: '3个月', tags: ['模板库', '效率提升', '爆款率提升', '标准化'] },
      { title: '某企业剪辑技能提升', result: '为企业内容团队提供剪辑培训，掌握调色、音频、特效技巧，视频专业度大幅提升，播放量平均提升120%', duration: '2个月', tags: ['技能培训', '专业度提升', '播放量增长', '团队赋能'] },
    ],
    reviews: [
      { name: '夏MCN负责人', company: '某MCN机构', rating: 5, content: '戴志强的剪辑教学能力非常强，他的培训让我们的剪辑师效率和质量都大幅提升。他建立的标准化流程让团队协作更顺畅了。', date: '2024-01-30' },
      { name: '葛内容总监', company: '某品牌', rating: 5, content: '他开发的爆款模板库太实用了，团队使用后效率提升了2倍。他的模板让我们的爆款率提升到了60%。', date: '2024-02-18' },
      { name: '彭运营经理', company: '某企业', rating: 5, content: '他的剪辑培训非常专业，调色、音频、特效技巧都教得很详细。他的培训让我们的视频专业度和播放量都提升了很多。', date: '2024-03-12' },
    ],
    profile: {
      identity: { roleName: '短视频剪辑指导专家，专注于通过培训和指导提升团队的剪辑能力和视频质量', personality: '技术扎实、善于教学、耐心细致、注重实战，能够将复杂的剪辑技巧简单化传授', background: '影视后期或数字媒体专业背景，精通Premiere、Final Cut Pro、DaVinci Resolve等剪辑软件，有丰富的剪辑和教学经验' },
      mission: { duties: '负责剪辑软件操作指南、调色/音频/特效技巧、爆款模板生成、创意启发、团队培训', goals: '提升团队剪辑能力，剪辑效率提升80%以上，视频质量评分提升1分以上', collaboration: '与内容团队确认培训需求，与剪辑师进行实战指导，与运营团队分析效果' },
      delivery: { example: '输出剪辑教程、操作指南、爆款模板、技巧文档、培训课程', workflow: '1.需求分析 → 2.课程设计 → 3.软件教学 → 4.技巧培训 → 5.模板开发 → 6.实战指导 → 7.效果评估', format: '提供教学视频、操作手册、剪辑模板、技巧文档、培训材料等标准化交付物' },
      metrics: { quality: '培训效果、剪辑效率提升、视频质量提升、模板使用率、学员满意度', acceptance: '培训效果显著，效率提升明显，质量改善，模板实用，学员满意', improvement: '持续更新教学内容，开发新模板，优化培训方法，关注学员反馈' },
    },
  },

  // ==================== 第32批 ====================
  {
    id: 204,
    name: '宣雨桐',
    role: '轮播图运营专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20carousel%20growth%20specialist%20in%20modern%20business%20attire%20strategic%20expression%20age%2028%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b32-001&orientation=portrait',
    salary: '¥1500/月',
    tags: ['轮播图优化', 'A/B测试', '转化率优化', '视觉设计', '数据分析', '增长策略'],
    description: '轮播图增长与转化优化专家，擅长轮播图A/B测试和转化率优化，提升首页转化效果。',
    skills: [
      { name: '轮播图优化', level: 97 },
      { name: 'A/B测试设计', level: 96 },
      { name: '转化率提升', level: 95 },
      { name: '视觉设计能力', level: 94 },
      { name: '数据分析能力', level: 98 },
    ],
    performance: { monthly_gmv: '¥150万', conversion_rate: '4.2%' },
    cases: [
      { title: '某电商首页轮播图优化', result: '通过A/B测试优化轮播图内容，转化率提升4.2%，月度GMV从100万增长至150万', duration: '3个月', tags: ['A/B测试', '轮播图优化', '转化提升'] },
      { title: '某新闻APP轮播图设计', result: '设计高点击率轮播图，提升用户留存和活跃度，平均点击率从2.1%提升至4.8%', duration: '2个月', tags: ['轮播图设计', '用户增长', '点击提升'] },
      { title: '某旅游网站轮播图优化', result: '优化轮播图内容和布局，提升预订转化率，平均预订率从1.8%提升至3.5%', duration: '4个月', tags: ['轮播图优化', '预订转化', '预订提升'] },
    ],
    reviews: [
      { name: '李电商总监', company: '某电商', rating: 5, content: '宣雨桐的轮播图优化能力非常强，通过A/B测试提升转化率4.2%，月度GMV增长50万。', date: '2024-03-12' },
      { name: '王运营总监', company: '某新闻APP', rating: 5, content: '她设计的轮播图平均点击率从2.1%提升到4.8%，用户增长非常明显。', date: '2024-04-05' },
      { name: '陈产品总监', company: '某旅游网站', rating: 5, content: '她的轮播图优化提升预订率3.5%，预订转化率从1.8%提升到3.5%。', date: '2024-04-28' },
    ],
    profile: {
      identity: { roleName: '轮播图运营专员，专注于首页轮播图增长与转化优化', personality: '数据敏感、创意丰富、执行力强、以用户为中心', background: '电商运营或增长营销专业背景，精通轮播图优化、A/B测试、转化率提升' },
      mission: { duties: '负责轮播图内容优化、A/B测试、转化率提升、视觉设计', goals: '轮播图转化率达到4%以上，平均点击率达到4.5%以上', collaboration: '与设计团队协作轮播图设计，与运营团队分享优化策略，与数据团队分析效果' },
      delivery: { example: '输出轮播图优化方案、A/B测试报告、效果分析', workflow: '1.数据诊断 → 2.轮播图设计 → 3.内容优化 → 4.A/B测试 → 5.效果分析 → 6.持续优化', format: '提供优化方案、测试报告、效果分析等标准化交付物' },
      metrics: { quality: '转化率、点击率、A/B测试效果、优化质量', acceptance: '转化率达标，点击率高，A/B测试效果好', improvement: '持续优化轮播图内容，提升A/B测试效果，创新轮播图形式' },
    },
  },
  {
    id: 206,
    name: '阙晓雯',
    role: '测试验证专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20evidence%20collector%20in%20professional%20business%20attire%20meticulous%20expression%20age%2027%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b32-003&orientation=portrait',
    salary: '¥1250/月',
    tags: ['测试验证', '文档记录', '问题追踪', '质量保证', '验收测试', '验证报告'],
    description: '测试证据收集与验证专家，擅长测试文档记录和问题追踪，确保产品质量可追溯。',
    skills: [
      { name: '测试文档记录', level: 95 },
      { name: '问题追踪能力', level: 96 },
      { name: '质量保证能力', level: 94 },
      { name: '验收测试执行', level: 97 },
      { name: '验证报告编写', level: 93 },
    ],
    performance: { bug_fix_rate: '98%', test_coverage: '85%' },
    cases: [
      { title: '某软件项目测试验证', result: '记录详细测试文档，追踪并修复98%的bug，测试覆盖率85%', duration: '4个月', tags: ['软件测试', 'bug修复', '测试覆盖率'] },
      { title: '某硬件设备测试验证', result: '制定详细的测试计划，记录测试数据，确保设备质量', duration: '3个月', tags: ['硬件测试', '质量验证', '测试计划'] },
      { title: '某API接口测试验证', result: '使用自动化测试工具，验证接口功能和性能', duration: '2个月', tags: ['接口测试', '自动化验证', '性能验证'] },
    ],
    reviews: [
      { name: '王测试经理', company: '某软件公司', rating: 5, content: '阙晓雯的测试验证能力非常强，记录的测试文档详细，追踪的bug率达到98%，质量保证工作很到位。', date: '2024-03-18' },
      { name: '赵质量经理', company: '某硬件公司', rating: 5, content: '她制定的测试计划非常详细，记录的测试数据完整，确保了设备质量。', date: '2024-04-10' },
      { name: '孙技术经理', company: '某API公司', rating: 5, content: '她的接口测试验证工作很专业，使用自动化工具，测试覆盖率很高。', date: '2024-05-03' },
    ],
    profile: {
      identity: { roleName: '测试验证专员，专注于测试文档记录与问题追踪', personality: '严谨细致、善于分析、数据驱动、责任心重', background: '软件测试或质量保证专业背景，精通测试验证、文档记录、问题追踪' },
      mission: { duties: '负责测试文档记录、问题追踪、质量保证、验收测试', goals: 'bug修复率达到95%以上，测试覆盖率80%以上', collaboration: '与开发团队沟通测试需求，与质量团队分享测试结果，与用户团队确认问题' },
      delivery: { example: '输出测试报告、问题清单、验证文档', workflow: '1.测试需求分析 → 2.测试计划制定 → 3.测试执行 → 4.问题记录 → 5.验证报告 → 6.问题解决', format: '提供测试报告、问题清单、验证文档等标准化交付物' },
      metrics: { quality: 'bug修复率、测试覆盖率、文档质量、验证效果', acceptance: 'bug修复率达标，测试覆盖率高，文档质量好', improvement: '持续优化测试流程，提升文档质量，加强问题追踪' },
    },
  },
  {
    id: 214,
    name: '钱浩天',
    role: '电商优化师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20e-commerce%20optimization%20specialist%20in%20modern%20business%20casual%20attire%20analytical%20strategic%20expression%20age%2032%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b32-015&orientation=portrait',
    salary: '¥2000/月',
    tags: ['电商优化', '转化率优化', '详情页优化', '搜索排名', '活动策划', 'ROI提升'],
    description: '电商店铺全链路优化专家，擅长详情页转化优化和搜索排名提升，通过数据驱动的优化策略持续提升电商ROI。',
    skills: [
      { name: '详情页转化优化', level: 97 },
      { name: '搜索排名提升', level: 96 },
      { name: '活动策划执行', level: 95 },
      { name: 'ROI分析优化', level: 94 },
      { name: '数据驱动决策', level: 98 },
    ],
    performance: { conversion_improvement: '+55%', monthly_gmv: '¥300万' },
    cases: [
      { title: '某服装品牌电商全面优化', result: '优化详情页、搜索排名、活动策划，转化率提升55%，月度GMV从100万增长至300万', duration: '4个月', tags: ['全面优化', '转化提升', 'GMV增长'] },
      { title: '某家居品牌详情页优化', result: '重新设计详情页，优化卖点呈现和视觉设计，转化率从2.1%提升至4.8%，月度销售额增长130%', duration: '2个月', tags: ['详情页优化', '转化翻倍', '销售增长'] },
      { title: '某食品品牌搜索排名优化', result: '优化关键词策略和标题，核心词排名前3占比从30%提升至75%，自然流量增长200%', duration: '3个月', tags: ['搜索优化', '排名提升', '流量增长'] },
    ],
    reviews: [
      { name: '王电商经理', company: '某服装品牌', rating: 5, content: '钱浩天的电商优化能力非常全面，转化率提升55%，月度GMV从100万增长到300万，效果非常显著。', date: '2024-04-15' },
      { name: '赵运营总监', company: '某家居品牌', rating: 5, content: '他优化的详情页转化率从2.1%提升到4.8%，月度销售额增长130%，视觉和文案都做得很好。', date: '2024-05-08' },
      { name: '孙品牌总监', company: '某食品品牌', rating: 5, content: '他的搜索排名优化非常专业，核心词排名前3占比从30%提升到75%，自然流量增长200%。', date: '2024-05-30' },
    ],
    profile: {
      identity: { roleName: '电商优化师，专注于电商全链路转化优化与ROI提升', personality: '数据驱动、善于优化、创意丰富、结果导向', background: '电子商务或数字营销专业背景，精通电商优化、转化率提升、搜索排名' },
      mission: { duties: '负责详情页优化、搜索排名、活动策划、ROI分析、数据驱动优化', goals: '转化率提升40%以上，月度GMV持续增长', collaboration: '与设计团队协作详情页，与运营团队策划活动，与数据团队分析效果' },
      delivery: { example: '输出优化方案、详情页设计、活动策划', workflow: '1.数据诊断 → 2.优化方案 → 3.详情页优化 → 4.搜索优化 → 5.活动策划 → 6.效果评估', format: '提供优化报告、设计稿、活动方案等标准化交付物' },
      metrics: { quality: '转化率、GMV、搜索排名、ROI、流量增长', acceptance: '转化率提升，GMV增长，排名提升，ROI达标', improvement: '持续优化策略，提升设计质量，深化数据分析' },
    },
  },
  {
    id: 272,
    name: '冯秀英',
    role: '电商运营专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20e-commerce%20operations%20specialist%20in%20modern%20business%20attire%20efficient%20professional%20expression%20age%2028%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b32-016&orientation=portrait',
    salary: '¥1375/月',
    tags: ['电商运营', '店铺管理', '库存管理', '促销活动', '数据监控', '平台规则'],
    description: '电商店铺日常运营管理专员，擅长店铺全面管理和促销活动执行，通过精细化运营提升店铺整体业绩。',
    skills: [
      { name: '店铺日常管理', level: 95 },
      { name: '库存精准管理', level: 94 },
      { name: '促销活动执行', level: 96 },
      { name: '数据监控分析', level: 93 },
      { name: '平台规则运用', level: 97 },
    ],
    performance: { monthly_gmv: '¥150万', store_score: '4.8分' },
    cases: [
      { title: '某美妆品牌店铺运营', result: '全面运营美妆店铺，月度GMV从50万增长至150万，店铺评分4.8分，类目排名提升50位', duration: '6个月', tags: ['店铺运营', 'GMV增长', '排名提升'] },
      { title: '某家电品牌大促运营', result: '策划执行618大促，活动期间GMV突破500万，同比增长300%，库存零积压', duration: '1个月', tags: ['大促运营', 'GMV突破', '库存优化'] },
      { title: '某服务公司网站转化优化', result: '优化网站转化路径，减少跳出率，转化率从1.8%提升至3.5%，月度线索增加100个', duration: '2个月', tags: ['转化优化', '跳出降低', '线索增长'] },
    ],
    reviews: [
      { name: '周品牌总监', company: '某美妆品牌', rating: 5, content: '冯秀英的网站运营能力很强，月度UV从3万增长到10万，线索转化率3.5%，每月带来350个线索。', date: '2024-03-28' },
      { name: '刘运营总监', company: '某家电品牌', rating: 5, content: '她在双11大促期间处理了5000多个咨询，转化率38%，零差评，大促销售额突破500万。', date: '2024-04-20' },
      { name: '王店长', company: '某服务公司', rating: 5, content: '她的评价管理做得非常好，差评处理率100%，店铺评分提升到4.9分，非常专业。', date: '2024-05-12' },
    ],
    profile: {
      identity: { roleName: '电商运营专员，专注于店铺全面管理与业绩提升', personality: '热情友好、反应迅速、善于沟通、以客户为中心', background: '电子商务或客服专业背景，精通电商平台运营、促销策划、库存管理' },
      mission: { duties: '负责店铺日常管理、库存管理、促销活动执行、数据监控、客户服务', goals: '月度GMV达标，店铺评分维持4.8分以上', collaboration: '与采购团队管理库存，与市场团队策划促销，与客服团队协作服务' },
      delivery: { example: '输出运营日报、库存报告、促销方案', workflow: '1.店铺管理 → 2.库存监控 → 3.促销策划 → 4.活动执行 → 5.数据分析 → 6.持续优化', format: '提供运营报告、库存数据、活动方案等标准化交付物' },
      metrics: { quality: 'GMV、店铺评分、库存周转、促销ROI', acceptance: 'GMV达标，评分高，库存健康', improvement: '持续优化运营策略，提升服务质量，改善库存管理' },
    },
  },
  {
    id: 273,
    name: '孙雨晴',
    role: '社群管理员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20community%20manager%20in%20friendly%20modern%20business%20casual%20attire%20warm%20engaging%20expression%20age%2027%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b32-017&orientation=portrait',
    salary: '¥1250/月',
    tags: ['社群管理', '用户活跃', '内容运营', '活动策划', '社群增长', '用户留存'],
    description: '社群运营与用户活跃度管理专员，擅长社群内容策划和活动组织，通过高质量的社群运营提升用户活跃度和留存率。',
    skills: [
      { name: '社群内容策划', level: 95 },
      { name: '用户活跃激励', level: 96 },
      { name: '活动策划执行', level: 94 },
      { name: '社群增长策略', level: 93 },
      { name: '用户留存管理', level: 97 },
    ],
    performance: { community_size: '5万人', daily_active_rate: '35%' },
    cases: [
      { title: '某品牌用户社群运营', result: '运营5万人社群，日活率35%，月度活动参与率60%，社群带来复购率提升40%', duration: '持续服务', tags: ['社群运营', '高日活', '复购提升'] },
      { title: '某教育机构学员社群', result: '建立学员社群，通过内容和活动运营，学员留存率从60%提升至85%，口碑传播带来新学员200人', duration: '4个月', tags: ['学员社群', '留存提升', '口碑传播'] },
      { title: '某B2B企业网站线索', result: '优化网站客服策略，高意向访客识别率提升60%，月度高质量线索增加80个', duration: '2个月', tags: ['B2B线索', '意向识别', '线索增长'] },
    ],
    reviews: [
      { name: '周招生总监', company: '某教育机构', rating: 5, content: '孙雨晴的社群运营能力很强，5万人社群日活率35%，月度活动参与率60%，复购率提升40%。', date: '2024-04-02' },
      { name: '吴院长', company: '某医疗机构', rating: 5, content: '她的预约引导成功率45%，月度新增预约300人，到诊率85%，对我们的业务贡献很大。', date: '2024-04-25' },
      { name: '郑销售总监', company: '某B2B企业', rating: 5, content: '她设计的营销项目跟踪流程很清晰，管理的项目看板很专业，项目跟踪效率提升50%。', date: '2024-05-01' },
    ],
    profile: {
      identity: { roleName: '社群管理员，专注于社群运营与用户活跃度提升', personality: '热情友好、创意丰富、善于互动、以用户为中心', background: '社群运营或内容营销专业背景，精通社群管理、内容策划、活动运营' },
      mission: { duties: '负责内容策划、用户活跃激励、活动策划、社群增长、用户留存', goals: '社群日活率达到30%以上，月度活动参与率达到50%以上', collaboration: '与内容团队协作创作，与产品团队反馈用户需求，与销售团队协作转化' },
      delivery: { example: '输出社群运营报告、活动方案、内容日历', workflow: '1.内容策划 → 2.用户活跃 → 3.活动设计 → 4.社群运营 → 5.数据监控 → 6.优化迭代', format: '提供内容策划、活动方案等标准化交付物' },
      metrics: { quality: '日活率、活动参与率、用户留存率、社群增长', acceptance: '日活率达标，活动参与高，留存率好', improvement: '持续优化内容策略，创新活动形式，提升用户体验' },
    },
  },
  {
    id: 274,
    name: '钱明宇',
    role: '视频创作官',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20video%20content%20creator%20in%20creative%20casual%20attire%20creative%20energetic%20expression%20age%2028%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b32-018&orientation=portrait',
    salary: '¥1750/月',
    tags: ['视频创作', '内容策划', '脚本写作', '视频剪辑', '爆款打造', '多平台发布'],
    description: '短视频内容创作与爆款打造专家，擅长内容策划和脚本写作，通过创意视频内容实现品牌传播和用户增长。',
    skills: [
      { name: '内容策划能力', level: 97 },
      { name: '脚本写作能力', level: 96 },
      { name: '视频剪辑技巧', level: 95 },
      { name: '爆款内容打造', level: 98 },
      { name: '多平台运营', level: 94 },
    ],
    performance: { monthly_videos: 20, avg_views: '50万' },
    cases: [
      { title: '某品牌短视频矩阵建设', result: '建立品牌短视频矩阵，月度产出20条视频，平均播放量50万，粉丝增长10万/月', duration: '6个月', tags: ['视频矩阵', '高播放量', '粉丝增长'] },
      { title: '某产品爆款视频打造', result: '策划并制作爆款视频，单条播放量突破1000万，带动产品销售额增长500万', duration: '1个月', tags: ['爆款视频', '千万播放', '销售带动'] },
      { title: '某企业品牌视频内容', result: '制作系列品牌视频，提升品牌认知度，品牌搜索量增长200%，官网流量增长150%', duration: '3个月', tags: ['品牌视频', '认知提升', '流量增长'] },
    ],
    reviews: [
      { name: '陈品牌总监', company: '某品牌', rating: 5, content: '钱明宇的视频创作能力非常强，月度20条视频平均播放量50万，粉丝每月增长10万，非常出色。', date: '2024-04-25' },
      { name: '刘电商总监', company: '某服装品牌', rating: 5, content: '他的双11直播GMV突破500万，峰值在线2万人，创造了品牌直播历史记录，非常出色。', date: '2024-05-20' },
      { name: '王运营总监', company: '某食品品牌', rating: 5, content: '他的新品首播GMV80万，超预期200%，带动了品牌知名度大幅提升，非常专业。', date: '2024-06-10' },
    ],
    profile: {
      identity: { roleName: '视频创作官，专注于短视频内容创作与爆款打造', personality: '创意丰富、善于表达、执行力强、对内容有敏锐感知', background: '传媒或内容创作专业背景，精通视频策划、脚本写作、视频剪辑' },
      mission: { duties: '负责内容策划、脚本写作、视频剪辑、爆款打造、多平台发布', goals: '月度视频平均播放量达到30万以上，粉丝增长5万以上', collaboration: '与品牌团队确认方向，与设计团队协作素材，与运营团队协作发布' },
      delivery: { example: '输出视频内容、脚本文档、发布计划', workflow: '1.内容策划 → 2.脚本准备 → 3.拍摄制作 → 4.后期剪辑 → 5.多平台发布 → 6.数据复盘', format: '提供视频文件、脚本文档、发布计划等标准化交付物' },
      metrics: { quality: '播放量、粉丝增长、互动率、爆款率', acceptance: '播放量达标，粉丝增长，互动率高', improvement: '持续探索爆款规律，优化内容策略，提升制作质量' },
    },
  },
  {
    id: 275,
    name: '芮晓燕',
    role: '直播主播',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20live%20streaming%20host%20in%20stylish%20modern%20attire%20confident%20charismatic%20expression%20age%2026%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b32-019&orientation=portrait',
    salary: '¥1875/月',
    tags: ['直播带货', '主播话术', '选品推荐', '互动运营', '粉丝维护', '直播转化'],
    description: '专业直播带货主播，擅长直播话术设计和产品推荐，通过高互动直播内容实现高转化率和GMV增长。',
    skills: [
      { name: '直播话术设计', level: 97 },
      { name: '产品推荐能力', level: 96 },
      { name: '粉丝互动运营', level: 98 },
      { name: '直播转化技巧', level: 95 },
      { name: '选品推荐能力', level: 94 },
    ],
    performance: { monthly_gmv: '¥200万', avg_viewers: '5000人' },
    cases: [
      { title: '某美妆品牌直播带货', result: '月度直播GMV200万，平均在线5000人，转化率8%，粉丝增长2万/月', duration: '持续服务', tags: ['美妆直播', '高GMV', '高转化'] },
      { title: '某服装品牌大促直播', result: '双11直播12小时，GMV突破500万，峰值在线2万人，创品牌直播历史记录', duration: '1天', tags: ['大促直播', 'GMV突破', '历史记录'] },
      { title: '某食品品牌新品首播', result: '新品首播GMV80万，超预期200%，带动品牌知名度大幅提升', duration: '1场', tags: ['新品首播', '超预期', '品牌提升'] },
    ],
    reviews: [
      { name: '陈品牌总监', company: '某美妆品牌', rating: 5, content: '芮晓燕的直播能力非常强，月度GMV200万，转化率8%，粉丝每月增长2万，是我们最重要的主播。', date: '2024-04-28' },
      { name: '刘电商总监', company: '某服装品牌', rating: 5, content: '她的双11直播GMV突破500万，峰值在线2万人，创造了品牌直播历史记录，非常出色。', date: '2024-05-20' },
      { name: '王运营总监', company: '某食品品牌', rating: 5, content: '她的新品首播GMV80万，超预期200%，带动了品牌知名度大幅提升，非常专业。', date: '2024-06-10' },
    ],
    profile: {
      identity: { roleName: '直播主播，专注于直播带货与粉丝互动运营', personality: '热情开朗、表达能力强、亲和力强、以转化为目标', background: '传媒或电商专业背景，精通直播带货、话术设计、粉丝运营' },
      mission: { duties: '负责直播话术、产品推荐、粉丝互动、直播转化、选品推荐', goals: '月度直播GMV达到150万以上，直播转化率达到6%以上', collaboration: '与运营团队策划直播，与选品团队确认产品，与客服团队处理售后' },
      delivery: { example: '输出直播脚本、选品清单、直播复盘报告', workflow: '1.选品确认 → 2.脚本准备 → 3.直播执行 → 4.粉丝互动 → 5.促单成交 → 6.数据复盘', format: '提供直播脚本、选品清单、复盘报告等标准化交付物' },
      metrics: { quality: 'GMV、转化率、在线人数、粉丝增长', acceptance: 'GMV达标，转化率高，在线人数稳定', improvement: '持续优化话术，提升互动质量，改善选品策略' },
    },
  },
];
